export const COLORS = {
  GREEN_BACKGROUND: 'green-background',
  GREEN_ACCENT: 'green-accent',
  GREEN_NEW: 'green-new',
  GREEN_DARK: 'green-dark',

  BLUE_BACKGROUND: 'blue-background',
  BLUE_ACCENT: 'blue-accent',
  BLUE: 'blue',
  BLUE_DARK: 'blue-dark',
  BLUE_DARK_BACKGROUND: 'blue-dark-background',

  TEXT_PRIMARY: 'text-primary',

  EGGPLANT_BACKGROUND: 'eggplant-background',
  EGGPLANT_ACCENT: 'eggplant-accent',
  EGGPLANT_DARK: 'eggplant-dark',

  TEAL_BACKGROUND: 'teal-background',
  TEAL_ACCENT: 'teal-accent',
  TEAL: 'teal',
  TEAL_DARK: 'teal-dark',

  RED_BACKGROUND: 'red-background',
  RED: 'red',
  RED_DARK: 'red-dark',

  YELLOW_BACKGROUND: 'yellow-background',
  YELLOW: 'yellow',

  GRAY_BACKGROUND: 'gray-background',
  GRAY_LIGHT: 'gray-light',
  GRAY_DISABLED: 'gray-disabled',
  GRAY: 'gray',
  GRAY_DARK: 'gray-dark',

  WHITE: 'white',
  BLACK: 'black',
} as const;
